import React from "react";
import { Card, CardBody, Input } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const InvestmentSummerySkeleton = ({
  colSize = "col-xxl-8 col-xl-8 col-lg-6 col-md-12 col-sm-12",
}) => {
  const isXL = window.matchMedia("(min-width: 1200px)").matches;
  const barCount = isXL ? 8 : 5;

  const barData = Array.from({ length: barCount }).map(() => {
    const total = Math.floor(Math.random() * 70) + 130;
    const seg1 = Math.floor(total * 0.6);
    const seg2 = total - seg1;
    return { total, seg1, seg2 };
  });

  return (
    <div className={colSize}>
      <Card className="card-height-100">
        <CardBody>
          {/* Header with title and dropdown skeleton */}
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="text-dark mb-0">
              <Skeleton width={150} height={40} />
            </h5>
            <div className="d-flex align-items-center justify-content-end">
              <Skeleton width={120} height={40} />
            </div>
          </div>

          {/* Chart skeleton container (matching a 350px height similar to your chart) */}
          <div style={{ height: "350px", padding: "0 10px" }}>
            <div
              className="d-flex justify-content-between align-items-end"
              style={{ height: "100%" }}
            >
              {barData.map((bar, index) => (
                <div
                  key={index}
                  className="d-flex flex-column align-items-center"
                  style={{ flex: 1, margin: "0 5px" }}
                >
                  {/* Stacked bar placeholder */}
                  <div
                    style={{
                      height: bar.total,
                      width: 30,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Skeleton
                      width={30}
                      height={bar.seg1}
                      style={{ borderRadius: "3px", marginBottom: "2px" }}
                    />
                    <Skeleton
                      width={30}
                      height={bar.seg2}
                      style={{ borderRadius: "3px" }}
                    />
                  </div>
                  {/* x-axis label placeholder */}
                  <div style={{ marginTop: "5px" }}>
                    <Skeleton width={40} height={10} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default InvestmentSummerySkeleton;
